import axios from 'axios';
import { handleError } from './utils';

const BASE = '/api/reports/accountability';

/** Only "All" asks for archived classes; "Active teachers" filters in the browser. */
const includeInactive = (teachersMode) => teachersMode === 'all';

/** Serialise a ReportQuery into URLSearchParams. */
export const accountabilityParams = (query) => {
  const params = new URLSearchParams();
  params.set('start', query.start);
  params.set('end', query.end);
  if (query.bucket) params.set('bucket', query.bucket);
  if (query.districtId) params.set('district_id', String(query.districtId));
  if (query.curriculumId) params.set('curriculum_id', String(query.curriculumId));
  if (query.subjectId) params.set('subject_id', String(query.subjectId));
  if (includeInactive(query.teachersMode)) params.set('include_inactive', 'true');
  (query.schoolIds || []).forEach((id) => params.append('school_ids', String(id)));
  return params;
};

/** Toolbar options for the whole scope. Dates and the other filters do not change them. */
export const getAccountabilityFilters = ({ districtId, teachersMode }) => {
  const params = new URLSearchParams();
  if (districtId) params.set('district_id', String(districtId));
  if (includeInactive(teachersMode)) params.set('include_inactive', 'true');
  const search = params.toString();
  return axios
    .get(`${BASE}/filters/${search ? `?${search}` : ''}`)
    .then((response) => ({ response }))
    .catch(handleError);
};

export const getAccountabilityReport = (query, parent) => {
  const params = accountabilityParams(query);
  if (parent) params.set('parent', parent);
  return axios
    .get(`${BASE}/?${params.toString()}`)
    .then(response => ({ response }))
    .catch(handleError);
};

export const getAccountabilityBands = (query, entity) => {
  const params = accountabilityParams(query);
  params.set('entity', entity);
  return axios
    .get(`${BASE}/bands/?${params.toString()}`)
    .then(response => ({ response }))
    .catch(handleError);
};

export const accountabilityExportUrl = (query) =>
  `${BASE}/export/?${accountabilityParams(query).toString()}`;

/**
 * Fetches the export CSV through axios (rather than a bare <a href>) so the
 * auth interceptor attaches the JWT, and so a browser navigation never lands
 * on the API route directly -- the dev server's history fallback would boot
 * the SPA there instead of returning the file.
 */
export const downloadAccountabilityExport = (query) => {
  const params = accountabilityParams(query);
  return axios
    .get(`${BASE}/export/?${params.toString()}`, { responseType: 'blob' })
    .then((response) => ({ response }))
    .catch(handleError);
};
